/* =========================
 * 베스트 쿠폰 추천 모듈
 * ========================= */

/**
 * 숫자 변환 (NaN → 기본값)
 */
function toNumber(v, def = 0) {
  const n = Number(v);
  return Number.isFinite(n) ? n : def;
}

/**
 * 날짜를 일 단위로 절삭
 */
function truncateDate(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

/**
 * 기준 날짜가 [from, until] 안에 포함되는지 확인
 */
function isWithinDateRange(from, until, ref = new Date()) {
  const refTime = truncateDate(ref).getTime();
  const startOk = !from || truncateDate(new Date(from)).getTime() <= refTime;
  const endOk   = !until || truncateDate(new Date(until)).getTime() >= refTime;
  return startOk && endOk;
}

/**
 * 장바구니 합계 계산
 * @param {Object} cart - 장바구니 데이터
 * @param {Object} opts
 * @param {string}   opts.units - 'major' | 'minor'
 * @param {number}   opts.minorFactor - minor 단위 변환 계수
 * @param {string[]} opts.applicableCollectionIds - 쿠폰 적용 대상 컬렉션 ID 목록
 */
function computeSubtotal(cart, { units = 'major', minorFactor = 100, applicableCollectionIds } = {}) {
  if (typeof cart === 'number') return Math.max(0, cart);
  if (!cart) return 0;

  // 컬렉션 필터링: 특정 컬렉션에 속한 상품만 합산
  if (applicableCollectionIds && applicableCollectionIds.length > 0 && Array.isArray(cart.items)) {
    const applicableKeys = new Set();
    const cartItemElements = document.querySelectorAll('li.cart-item[data-collection-ids]');

    cartItemElements.forEach(el => {
      const collectionIdsStr = el.getAttribute('data-collection-ids') || '';
      const collectionIds = collectionIdsStr.split(',').filter(Boolean);
      const hasApplicable = collectionIds.some(id => applicableCollectionIds.includes(id));
      if (hasApplicable) {
        const key = el.getAttribute('data-key');
        if (key) applicableKeys.add(key);
      }
    });

    const raw = cart.items
      .filter(it => applicableKeys.has(it.key))
      .reduce((s, it) => s + toNumber(it.original_line_price), 0);

    return units === 'minor' ? Math.floor(raw / minorFactor) : raw;
  }

  if (cart.subtotal != null) return Math.max(0, cart.subtotal);

  if (Array.isArray(cart.lineItems)) {
    return cart.lineItems.reduce((s, li) =>
      s + toNumber(li.price) * toNumber(li.quantity, 1), 0);
  }

  if (Array.isArray(cart.items)) {
    const raw = cart.items.reduce((s, it) =>
      s + (it.final_line_price != null
        ? toNumber(it.final_line_price)
        : toNumber(it.price) * toNumber(it.quantity, 1)), 0);
    return units === 'minor' ? Math.floor(raw / minorFactor) : raw;
  }

  return 0;
}

/**
 * 쿠폰 유효성 체크
 */
function isCouponValid(c, subtotal, ref = new Date()) {
  if (!c || c.is_used || !c.is_active) return false;
  if (!isWithinDateRange(c.valid_from, c.valid_until, ref)) return false;
  if (c.minimum_amount && subtotal < toNumber(c.minimum_amount)) return false;
  return true;
}

/**
 * 쿠폰 절감액 계산 (max cap 반영)
 */
function calcSavings(subtotal, c) {
  let save = 0;

  if (c.coupon_type === 'percentage') {
    save = (subtotal * toNumber(c.discount_value)) / 100;
  }
  if (c.coupon_type === 'fixed_amount') {
    save = toNumber(c.discount_value);
  }

  if (c.maximum_discount) {
    save = Math.min(save, toNumber(c.maximum_discount));
  }

  save = Math.min(save, subtotal); // 초과 방지
  return Math.floor(Math.max(0, save));
}

/**
 * 쿠폰 할인 적용 대상 컬렉션 ID (할인미적용 컬렉션)
 */
const FIXED_APPLICABLE_COLLECTION_IDS = ['688861118835'];

/**
 * 최적 쿠폰 추천
 * @return {Object|null} { index, code, savings } or null
 */
function recommendBestCoupon(cart, coupons, ref = new Date(), opts) {
  const subtotal = computeSubtotal(cart, { ...opts, applicableCollectionIds: FIXED_APPLICABLE_COLLECTION_IDS });

  const candidates = coupons
    .map((c, i) => {
      const valid = isCouponValid(c, subtotal, ref);
      const savings = valid ? calcSavings(subtotal, c) : 0;
      return { index: i, code: c.coupon_code, savings, valid };
    })
    .filter(e => e.valid && e.savings > 0);

  if (!candidates.length) return null;

  candidates.sort((a, b) => b.savings - a.savings);
  const { index, code, savings } = candidates[0];
  return { index, code, savings };
}
